import 'common'

import(/* webpackChunkName: "Dropdown" */ 'dropdown').then(module => new module.Dropdown().mount())

import(/* webpackChunkName: "sideNav" */ 'side_nav').then(module => module.sideNav())

import(/* webpackChunkName: "Accordion" */ 'accordion').then(module =>
  new module.Accordion().mount()
)
